<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KWEbTZ/tc-custom/9781488008719.jpg?1705766069309" alt="This image is the cover for the book High-Risk Reunion, Lone Star Justice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">High-Risk Reunion, Lone Star Justice
      </h1>
      <p class="bookDescription body article font2">
        <b>When a prosecutor is threatened by dangerous criminals, she finds refuge with the Texas Ranger she never stopped loving in this romantic suspense novel.</b><br/><br/>When district attorney Tory Carson returns home after a long day in court prosecuting a gang leader, she finds her house trashed. Concerned that the vandalism is connected to the trial, the local police chief calls the Texas Rangers . . . and her former love Cade Morgan responds.<br/><br/>Tory’s history with Cade—and the secret they share—makes her reluctant to let him back into her life. But Tory doesn’t want to choose between bringing down a gang leader and protecting her teenage daughter. As the case continues and the threat escalates, the safest place for Tory and her daughter is at Cade’s ranch. But can Cade protect them long enough for Tory to bring the criminal to justice?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margaret Daley
      </h2>
      
      <p class="authorDescription body article">Margaret Daley, an award-winning author of eighty-three books, has been married for over forty years and is a firm believer in romance and love. When she isn&rsquo;t traveling, she&rsquo;s writing love stories, often with a suspense thread, and corralling her three cats that think they rule her household. To find out more about Margaret visit her website at http://www.margaretdaley.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b49f06a